module.exports = __webpack_public_path__ + "static/img/Jack-Billings.5ce84bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Billings.jpg
// module id = r8G5
// module chunks = 0